var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form',{on:{"submit":_vm.search}},[_c('b-form-group',{attrs:{"horizontal":""}},[_c('b-input-group',[_c('b-form-input',{attrs:{"placeholder":"Type to search"},model:{value:(_vm.q),callback:function ($$v) {_vm.q=$$v},expression:"q"}}),_c('b-btn',{attrs:{"disabled":!_vm.q},on:{"click":_vm.search}},[_vm._v("search")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }